// extracted by mini-css-extract-plugin
var _1 = "webpack-system-elements-DynamicFields-DynamicFields-module__addButton";
var _2 = "webpack-system-elements-DynamicFields-DynamicFields-module__container";
var _3 = "webpack-system-elements-DynamicFields-DynamicFields-module__headerFieldRemoveButton";
var _4 = "webpack-system-elements-DynamicFields-DynamicFields-module__headerFieldWrapper";
export { _1 as "addButton", _2 as "container", _3 as "headerFieldRemoveButton", _4 as "headerFieldWrapper" }
